(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-article"]) return;
  try {
    
  class McArticlePage extends HTMLElement {
    constructor() {
      super();
      this.moneyFormat = this.dataset.moneyFormat || '£{{amount}}';
      this.maxSidebar = 6;
      this.abortController = new AbortController();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    connectedCallback() {
      /* Find all product links in the article body */
      const body = this.querySelector('.mca__body');
      if (!body) return;

      const links = body.querySelectorAll('a[href*="/products/"]');
      const handles = new Set();

      links.forEach(link => {
        const href = link.getAttribute('href') || '';
        const match = href.match(/\/products\/([a-zA-Z0-9\-_]+)/);
        if (match && match[1]) {
          handles.add(match[1]);
        }
      });

      if (handles.size === 0) return;

      this.loadProducts([...handles]);
    }

    async loadProducts(handles) {
      const products = [];

      /* Fetch each product's JSON — parallel for speed */
      const results = await Promise.allSettled(
        handles.map(handle =>
          fetch(`/products/${handle}.js`, { signal: this.abortController.signal }).then(r => {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
        )
      );

      results.forEach(result => {
        if (result.status === 'fulfilled') {
          products.push(result.value);
        }
      });

      if (products.length === 0) return;

      this.classList.add('mca--has-products');
      this.renderSidebar(products);
      this.renderGrid(products);
    }

    renderSidebar(products) {
      const sidebar = this.querySelector('.mca__sidebar');
      const container = this.querySelector('.mca__sidebar-products');
      if (!sidebar || !container) return;

      const display = products.slice(0, this.maxSidebar);
      container.innerHTML = display.map(p => this.sidebarCard(p)).join('');
      sidebar.removeAttribute('hidden');

      /* Show "view all" link if more products than sidebar limit */
      if (products.length > this.maxSidebar) {
        const viewAll = sidebar.querySelector('.mca__sidebar-viewall');
        if (viewAll) {
          viewAll.textContent = `View all ${products.length} products ↓`;
          viewAll.removeAttribute('hidden');
        }
      }
    }

    renderGrid(products) {
      const grid = this.querySelector('.mca__grid');
      const container = this.querySelector('.mca__grid-products');
      if (!grid || !container) return;

      container.innerHTML = products.map(p => this.gridCard(p)).join('');
      grid.removeAttribute('hidden');
    }

    sidebarCard(product) {
      const img = this.sizedImage(product.featured_image, 128);
      const price = this.formatMoney(product.price);
      const comparePrice = product.compare_at_price && product.compare_at_price > product.price
        ? `<span class="mca__sp-price-was">${this.formatMoney(product.compare_at_price)}</span>`
        : '';

      return `
        <a href="/products/${this.esc(product.handle)}" class="mca__sp-card">
          <div class="mca__sp-img">
            <img src="${this.esc(img)}" alt="${this.esc(product.title)}" loading="lazy" width="64" height="64">
          </div>
          <div class="mca__sp-info">
            ${product.vendor ? `<span class="mca__sp-vendor">${this.esc(product.vendor)}</span>` : ''}
            <span class="mca__sp-name">${this.esc(product.title)}</span>
            <span class="mca__sp-price">${price}${comparePrice}</span>
          </div>
        </a>
      `;
    }

    gridCard(product) {
      const img = this.sizedImage(product.featured_image, 600);
      const price = this.formatMoney(product.price);
      const comparePrice = product.compare_at_price && product.compare_at_price > product.price
        ? `<span class="mca__gp-price-was">${this.formatMoney(product.compare_at_price)}</span>`
        : '';

      return `
        <a href="/products/${this.esc(product.handle)}" class="mca__gp-card">
          <div class="mca__gp-img">
            <img src="${this.esc(img)}" alt="${this.esc(product.title)}" loading="lazy" width="300" height="300">
          </div>
          <div class="mca__gp-info">
            ${product.vendor ? `<span class="mca__gp-vendor">${this.esc(product.vendor)}</span>` : ''}
            <h3 class="mca__gp-name">${this.esc(product.title)}</h3>
            <div class="mca__gp-price">
              <span class="mca__gp-price-current">${price}</span>
              ${comparePrice}
            </div>
          </div>
        </a>
      `;
    }

    sizedImage(url, width) {
      if (!url) return '';
      /* Shopify CDN supports ?width= parameter */
      if (url.startsWith('//')) url = 'https:' + url;
      try {
        const u = new URL(url);
        u.searchParams.set('width', width);
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    formatMoney(cents) {
      if (cents == null) return '';
      const amount = (cents / 100).toFixed(2);
      const amountWithComma = amount.replace('.', ',');
      const noDecimals = Math.floor(cents / 100).toString();

      return this.moneyFormat
        .replace('{{amount_with_comma_separator}}', amountWithComma.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
        .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
        .replace('{{amount_no_decimals}}', noDecimals.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))
        .replace('{{amount}}', amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
    }

    esc(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  }

  if (!customElements.get('mc-article-page')) {
    customElements.define('mc-article-page', McArticlePage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-collection-slider"] && !Shopify.designMode) return;
  try {
    
  class McFeaturedCollection extends HTMLElement {
    connectedCallback() {
      this.prevBtn = this.querySelector('.mcfc__nav-btn--prev');
      this.nextBtn = this.querySelector('.mcfc__nav-btn--next');

      if (!this.prevBtn || !this.nextBtn) return;

      /* The Horizon carousel uses <slideshow-slides> as the scroll container */
      this.scroller = this.querySelector('slideshow-slides');
      if (!this.scroller) return;

      this.prevBtn.addEventListener('click', () => this.scroll('left'));
      this.nextBtn.addEventListener('click', () => this.scroll('right'));
      this.scroller.addEventListener('scroll', () => this.updateButtons(), { passive: true });

      /* Wait for layout to settle, then update */
      requestAnimationFrame(() => {
        this.updateButtons();
        /* Also listen for resize */
        new ResizeObserver(() => this.updateButtons()).observe(this.scroller);
      });
    }

    scroll(direction) {
      /* Find slide elements to calculate scroll distance */
      const slide = this.scroller.querySelector('slideshow-slide');
      if (!slide) return;
      const gap = parseInt(getComputedStyle(this.scroller).columnGap) || 12;
      const scrollAmount = slide.offsetWidth + gap;
      const offset = direction === 'left' ? -scrollAmount : scrollAmount;
      this.scroller.scrollBy({ left: offset, behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.scroller) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
      this.prevBtn.disabled = scrollLeft <= 2;
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }
  }

  if (!customElements.get('mc-featured-collection')) {
    customElements.define('mc-featured-collection', McFeaturedCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-distillery-carousel"] && !Shopify.designMode) return;
  try {
    
  class McDistilleryScroll extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.dragMoved = false;
      this._boundDragMove = this.onDragMove.bind(this);
      this._boundDragEnd = this.onDragEnd.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.dc__track');
      this.prevBtn = this.querySelector('.dc__nav-btn--prev');
      this.nextBtn = this.querySelector('.dc__nav-btn--next');

      if (!this.track) return;

      /* Navigation arrows */
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this.scroll('left'));
        this.nextBtn.addEventListener('click', () => this.scroll('right'));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        this.updateButtons();
      }

      /* Drag-to-scroll */
      this.track.addEventListener('mousedown', this.onDragStart.bind(this));
      window.addEventListener('mousemove', this._boundDragMove);
      window.addEventListener('mouseup', this._boundDragEnd);

      /* Prevent click after drag */
      this.track.addEventListener('click', (e) => {
        if (this.dragMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      /* Keyboard arrow navigation */
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.scroll('left');
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.scroll('right');
        }
      });
    }

    disconnectedCallback() {
      window.removeEventListener('mousemove', this._boundDragMove);
      window.removeEventListener('mouseup', this._boundDragEnd);
    }

    scroll(direction) {
      if (!this.track) return;
      const card = this.track.querySelector('.dc__card');
      if (!card) return;
      const scrollAmount = card.offsetWidth + 16;
      const offset = direction === 'left' ? -scrollAmount : scrollAmount;
      this.track.scrollBy({ left: offset, behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prevBtn.disabled = scrollLeft <= 2;
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }

    onDragStart(e) {
      this.isDragging = true;
      this.dragMoved = false;
      this.startX = e.pageX - this.track.offsetLeft;
      this.scrollLeft = this.track.scrollLeft;
    }

    onDragMove(e) {
      if (!this.isDragging) return;
      const x = e.pageX - this.track.offsetLeft;
      const walk = (x - this.startX) * 1.2;
      if (Math.abs(walk) > 5) {
        if (!this.dragMoved) {
          this.dragMoved = true;
          this.track.classList.add('dc__track--dragging');
        }
        e.preventDefault();
      }
      this.track.scrollLeft = this.scrollLeft - walk;
    }

    onDragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('dc__track--dragging');
      requestAnimationFrame(() => {
        this.updateButtons();
        setTimeout(() => { this.dragMoved = false; }, 10);
      });
    }
  }

  if (!customElements.get('mc-distillery-scroll')) {
    customElements.define('mc-distillery-scroll', McDistilleryScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-gifting-guide"] && !Shopify.designMode) return;
  try {
    
  class McGiftingTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.panels = [];
      this.tracks = [];
      this.prevBtn = null;
      this.nextBtn = null;
      this.activeIndex = 0;
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.dragMoved = false;

      /* Store bound references for window listeners so we can remove them */
      this._boundDragMove = this.onDragMove.bind(this);
      this._boundDragEnd = this.onDragEnd.bind(this);
    }

    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.gg__tab')];
      this.panels = [...this.querySelectorAll('.gg__panel')];
      this.tracks = [...this.querySelectorAll('.gg__track')];
      this.prevBtn = this.querySelector('.gg__nav-btn--prev');
      this.nextBtn = this.querySelector('.gg__nav-btn--next');

      if (!this.tabs.length) return;

      /* Tab events */
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick.bind(this));
        tab.addEventListener('keydown', this.handleKeyDown.bind(this));
      });

      /* Nav arrows */
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollTrack('left'));
        this.nextBtn.addEventListener('click', () => this.scrollTrack('right'));
      }

      /* Per-track drag + scroll + keyboard listeners */
      this.tracks.forEach((track) => {
        track.addEventListener('mousedown', this.onDragStart.bind(this));
        track.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
        track.addEventListener('click', (e) => {
          if (this.dragMoved) { e.preventDefault(); e.stopPropagation(); }
        }, true);

        /* Keyboard arrow navigation for carousel */
        track.setAttribute('tabindex', '0');
        track.setAttribute('aria-label', 'Product carousel, use arrow keys to scroll');
        track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.scrollTrack('right');
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.scrollTrack('left');
          }
        });
      });

      window.addEventListener('mousemove', this._boundDragMove);
      window.addEventListener('mouseup', this._boundDragEnd);

      this.updateNavButtons();
    }

    disconnectedCallback() {
      window.removeEventListener('mousemove', this._boundDragMove);
      window.removeEventListener('mouseup', this._boundDragEnd);
    }

    get activeTrack() {
      return this.tracks[this.activeIndex] || null;
    }

    /* --- Tab switching --- */
    handleTabClick(e) {
      const index = parseInt(e.currentTarget.dataset.tabIndex, 10);
      if (index === this.activeIndex) return;
      this.switchTab(index);
    }

    handleKeyDown(e) {
      const { key } = e;
      let newIndex = this.activeIndex;

      if (key === 'ArrowRight' || key === 'ArrowDown') {
        e.preventDefault();
        newIndex = (this.activeIndex + 1) % this.tabs.length;
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        e.preventDefault();
        newIndex = (this.activeIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (key === 'Home') {
        e.preventDefault();
        newIndex = 0;
      } else if (key === 'End') {
        e.preventDefault();
        newIndex = this.tabs.length - 1;
      }

      if (newIndex !== this.activeIndex) {
        this.switchTab(newIndex);
        this.tabs[newIndex].focus();
      }
    }

    switchTab(newIndex) {
      /* Deactivate current */
      this.tabs[this.activeIndex].classList.remove('gg__tab--active');
      this.tabs[this.activeIndex].setAttribute('aria-selected', 'false');
      this.panels[this.activeIndex].classList.remove('gg__panel--active');
      this.panels[this.activeIndex].hidden = true;

      /* Activate new */
      this.activeIndex = newIndex;
      this.tabs[newIndex].classList.add('gg__tab--active');
      this.tabs[newIndex].setAttribute('aria-selected', 'true');
      this.panels[newIndex].hidden = false;

      /* Force reflow for transition */
      void this.panels[newIndex].offsetHeight;
      this.panels[newIndex].classList.add('gg__panel--active');

      /* Scroll active tab into view on mobile */
      this.tabs[newIndex].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });

      /* Reset carousel scroll position and update nav */
      if (this.activeTrack) {
        this.activeTrack.scrollLeft = 0;
      }
      this.updateNavButtons();
    }

    /* --- Carousel scrolling --- */
    scrollTrack(direction) {
      const track = this.activeTrack;
      if (!track) return;
      const card = track.querySelector('.gg__card');
      if (!card) return;
      const scrollAmount = card.offsetWidth + 16;
      track.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    }

    updateNavButtons() {
      if (!this.prevBtn || !this.nextBtn) return;
      const track = this.activeTrack;
      if (!track) return;
      const { scrollLeft, scrollWidth, clientWidth } = track;
      this.prevBtn.disabled = scrollLeft <= 2;
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }

    /* --- Drag to scroll --- */
    onDragStart(e) {
      const track = e.currentTarget;
      this.isDragging = true;
      this.dragMoved = false;
      this.dragTrack = track;
      this.startX = e.pageX - track.offsetLeft;
      this.scrollLeft = track.scrollLeft;
    }

    onDragMove(e) {
      if (!this.isDragging || !this.dragTrack) return;
      const x = e.pageX - this.dragTrack.offsetLeft;
      const walk = (x - this.startX) * 1.2;
      if (Math.abs(walk) > 5) {
        if (!this.dragMoved) {
          this.dragMoved = true;
          this.dragTrack.classList.add('gg__track--dragging');
        }
        e.preventDefault();
      }
      this.dragTrack.scrollLeft = this.scrollLeft - walk;
    }

    onDragEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      if (this.dragTrack) {
        this.dragTrack.classList.remove('gg__track--dragging');
      }
      this.dragTrack = null;
      requestAnimationFrame(() => {
        this.updateNavButtons();
        setTimeout(() => { this.dragMoved = false; }, 10);
      });
    }
  }

  if (!customElements.get('mc-gifting-tabs')) {
    customElements.define('mc-gifting-tabs', McGiftingTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-header"] && !Shopify.designMode) return;
  try {
    
  /* =====================================================
     MC: INLINE SEARCH COMPONENT
     Predictive search in the header nav bar
     ===================================================== */
  class McInlineSearch extends HTMLElement {
    #controller = null;
    #debounceTimer = null;
    #currentIndex = -1;
    #items = [];

    connectedCallback() {
      this.input = this.querySelector('.mch__search-input');
      this.clearBtn = this.querySelector('.mch__search-clear');
      this.resultsEl = this.querySelector('.mch__results');
      this.kbdEl = this.querySelector('.mch__search-kbd');
      this.viewAllEl = this.querySelector('.mch__results-viewall');
      this.moneyFormat = this.closest('mc-site-header')?.dataset?.moneyFormat || '£{{amount}}';

      if (!this.input) return;

      this.input.addEventListener('input', this.#onInput.bind(this));
      this.input.addEventListener('keydown', this.#onKeyDown.bind(this));
      this.input.addEventListener('focus', this.#onFocus.bind(this));
      this.clearBtn?.addEventListener('click', this.#onClear.bind(this));

      /* Close on click outside */
      document.addEventListener('click', this.#onClickOutside.bind(this));

      /* Cmd+K shortcut */
      document.addEventListener('keydown', this.#onGlobalKey.bind(this));
    }

    disconnectedCallback() {
      this.#controller?.abort();
      clearTimeout(this.#debounceTimer);
    }

    #onInput() {
      const query = this.input.value.trim();

      /* Toggle clear button and kbd hint */
      if (this.clearBtn) this.clearBtn.hidden = query.length === 0;
      if (this.kbdEl) this.kbdEl.hidden = query.length > 0;

      if (query.length < 2) {
        this.#hideResults();
        return;
      }

      clearTimeout(this.#debounceTimer);
      this.#debounceTimer = setTimeout(() => this.#search(query), 250);
    }

    #onFocus() {
      const query = this.input.value.trim();
      if (query.length >= 2 && this.resultsEl && !this.resultsEl.hidden) {
        this.#showResults();
      }
    }

    #onKeyDown(e) {
      if (!this.resultsEl || this.resultsEl.hidden) {
        if (e.key === 'Escape') {
          this.input.blur();
        }
        return;
      }

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          this.#navigate(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          this.#navigate(-1);
          break;
        case 'Enter':
          e.preventDefault();
          if (this.#currentIndex >= 0 && this.#items[this.#currentIndex]) {
            window.location.href = this.#items[this.#currentIndex].getAttribute('href');
          } else {
            this.input.closest('form')?.submit();
          }
          break;
        case 'Escape':
          this.#hideResults();
          this.input.blur();
          break;
      }
    }

    #onGlobalKey(e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        this.input?.focus();
        this.input?.select();
      }
    }

    #onClickOutside(e) {
      if (!this.contains(e.target)) {
        this.#hideResults();
      }
    }

    #onClear() {
      this.input.value = '';
      this.input.focus();
      if (this.clearBtn) this.clearBtn.hidden = true;
      if (this.kbdEl) this.kbdEl.hidden = false;
      this.#hideResults();
    }

    #navigate(direction) {
      this.#items = [...this.resultsEl.querySelectorAll('[role="option"]')];
      if (this.#items.length === 0) return;

      /* Remove current selection */
      if (this.#currentIndex >= 0 && this.#items[this.#currentIndex]) {
        this.#items[this.#currentIndex].setAttribute('aria-selected', 'false');
      }

      this.#currentIndex += direction;
      if (this.#currentIndex >= this.#items.length) this.#currentIndex = 0;
      if (this.#currentIndex < 0) this.#currentIndex = this.#items.length - 1;

      const item = this.#items[this.#currentIndex];
      item.setAttribute('aria-selected', 'true');
      item.scrollIntoView({ block: 'nearest' });
    }

    async #search(query) {
      this.#controller?.abort();
      this.#controller = new AbortController();

      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor`;
        const response = await fetch(url, { signal: this.#controller.signal });

        if (!response.ok) throw new Error(response.status);

        const data = await response.json();
        this.#renderResults(data.resources?.results || {}, query);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Search error:', error);
        }
      }
    }

    #renderResults(results, query) {
      const products = results.products || [];
      const queries = results.queries || [];
      const collections = results.collections || [];
      const hasResults = products.length > 0 || queries.length > 0 || collections.length > 0;

      /* Query suggestions */
      const queriesEl = this.resultsEl.querySelector('.mch__results-queries');
      if (queriesEl) {
        queriesEl.innerHTML = queries.map(q =>
          `<a href="${this.#esc(q.url)}" class="mch__rq" role="option" aria-selected="false">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            ${this.#esc(q.text)}
          </a>`
        ).join('');
      }

      /* Products */
      const productsEl = this.resultsEl.querySelector('.mch__results-products');
      if (productsEl) {
        productsEl.innerHTML = products.map(p => {
          const img = p.image ? `<img src="${this.#esc(p.image)}" alt="" loading="lazy" width="48" height="48">` : '';
          return `<a href="${this.#esc(p.url)}" class="mch__rp" role="option" aria-selected="false">
            <div class="mch__rp-img">${img}</div>
            <div class="mch__rp-info">
              ${p.vendor ? `<span class="mch__rp-vendor">${this.#esc(p.vendor)}</span>` : ''}
              <span class="mch__rp-title">${this.#esc(p.title)}</span>
              <span class="mch__rp-price">${this.#formatMoney(p.price)}</span>
            </div>
          </a>`;
        }).join('');
      }

      /* Collections */
      const collectionsEl = this.resultsEl.querySelector('.mch__results-collections');
      if (collectionsEl) {
        collectionsEl.innerHTML = collections.map(c =>
          `<a href="${this.#esc(c.url)}" class="mch__rc" role="option" aria-selected="false">
            <svg class="mch__rc-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
            ${this.#esc(c.title)}
          </a>`
        ).join('');
      }

      /* Empty state */
      const emptyEl = this.resultsEl.querySelector('.mch__results-empty');
      if (emptyEl) emptyEl.hidden = hasResults;

      /* View all link */
      if (this.viewAllEl) {
        this.viewAllEl.href = `/search?q=${encodeURIComponent(query)}&type=product`;
        this.viewAllEl.hidden = !hasResults;
      }

      this.#currentIndex = -1;
      this.#showResults();
    }

    #showResults() {
      if (this.resultsEl) {
        this.resultsEl.hidden = false;
        this.input?.setAttribute('aria-expanded', 'true');
        this.closest('mc-site-header')?.classList.add('mch--search-open');
      }
    }

    #hideResults() {
      if (this.resultsEl) {
        this.resultsEl.hidden = true;
        this.input?.setAttribute('aria-expanded', 'false');
        this.closest('mc-site-header')?.classList.remove('mch--search-open');
        this.#currentIndex = -1;
      }
    }

    #formatMoney(priceStr) {
      if (!priceStr) return '';
      /* Shopify suggest API returns price as string like "29.99" */
      return this.moneyFormat
        .replace('{{amount}}', priceStr)
        .replace('{{amount_with_comma_separator}}', priceStr.replace('.', ','))
        .replace('{{amount_no_decimals}}', Math.floor(parseFloat(priceStr)).toString())
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.floor(parseFloat(priceStr)).toString());
    }

    #esc(str) {
      if (!str) return '';
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  }

  if (!customElements.get('mc-inline-search')) {
    customElements.define('mc-inline-search', McInlineSearch);
  }

  /* =====================================================
     MC: SITE HEADER COMPONENT
     Handles mobile drawer, dropdown menus
     ===================================================== */
  class McSiteHeader extends HTMLElement {
    connectedCallback() {
      this.burger = this.querySelector('.mch__burger');
      this.drawer = this.querySelector('.mch__drawer');
      this.backdrop = this.querySelector('.mch__backdrop');
      this.searchToggle = this.querySelector('.mch__search-toggle');

      /* Hamburger menu */
      this.burger?.addEventListener('click', () => this.#toggleDrawer());
      this.backdrop?.addEventListener('click', () => this.#closeAll());

      /* Mobile search toggle — focus the drawer search input */
      this.searchToggle?.addEventListener('click', () => {
        this.#openDrawer();
        requestAnimationFrame(() => {
          this.drawer?.querySelector('.mch__drawer-input')?.focus();
        });
      });

      /* Desktop dropdown menus */
      this.querySelectorAll('.mch__nav-link--parent').forEach(btn => {
        btn.addEventListener('click', (e) => this.#toggleDropdown(e.currentTarget));
      });

      /* Close dropdowns on outside click */
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.mch__nav-dropdown')) {
          this.#closeDropdowns();
        }
      });

      /* Close drawer on Escape */
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.#closeAll();
      });
    }

    #toggleDrawer() {
      const open = this.drawer?.hidden !== false;
      if (open) this.#openDrawer();
      else this.#closeDrawer();
    }

    #openDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      this.burger?.setAttribute('aria-expanded', 'true');
      this.classList.add('mch--drawer-open');
      document.body.style.overflow = 'hidden';
    }

    #closeDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = true;
      this.burger?.setAttribute('aria-expanded', 'false');
      this.classList.remove('mch--drawer-open');
      document.body.style.overflow = '';
    }

    #toggleDropdown(btn) {
      const dropdown = btn.closest('.mch__nav-dropdown');
      const isOpen = dropdown.classList.contains('mch__nav-dropdown--open');

      this.#closeDropdowns();

      if (!isOpen) {
        dropdown.classList.add('mch__nav-dropdown--open');
        btn.setAttribute('aria-expanded', 'true');
      }
    }

    #closeDropdowns() {
      this.querySelectorAll('.mch__nav-dropdown--open').forEach(d => {
        d.classList.remove('mch__nav-dropdown--open');
        d.querySelector('.mch__nav-link--parent')?.setAttribute('aria-expanded', 'false');
      });
    }

    #closeAll() {
      this.#closeDrawer();
      this.#closeDropdowns();
    }
  }

  if (!customElements.get('mc-site-header')) {
    customElements.define('mc-site-header', McSiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-policy-page"]) return;
  try {
    
  class McPolicyPage extends HTMLElement {
    constructor() {
      super();
      this.tocList = null;
      this.headings = [];
      this.observer = null;
    }

    connectedCallback() {
      this.tocList = this.querySelector('.mcp__toc-list');
      if (!this.tocList) return;

      this.buildTOC();
      this.setupScrollSpy();
    }

    buildTOC() {
      const body = this.querySelector('.mcp__rte');
      if (!body) return;

      /* Find all h2 and h3 headings */
      const headings = body.querySelectorAll('h2, h3');
      if (headings.length === 0) {
        /* Hide sidebar if no headings */
        const sidebar = this.querySelector('.mcp__sidebar');
        if (sidebar) sidebar.style.display = 'none';
        /* Make layout single column */
        const layout = this.querySelector('.mcp__layout');
        if (layout) layout.style.gridTemplateColumns = '1fr';
        return;
      }

      const fragment = document.createDocumentFragment();

      headings.forEach((heading, i) => {
        /* Add id for anchor linking */
        const id = 'section-' + i + '-' + heading.textContent
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '')
          .slice(0, 40);

        heading.id = id;
        this.headings.push({ el: heading, id: id });

        /* Create TOC item */
        const li = document.createElement('li');
        li.className = 'mcp__toc-item' + (heading.tagName === 'H3' ? ' mcp__toc-item--sub' : '');

        const a = document.createElement('a');
        a.className = 'mcp__toc-link';
        a.href = '#' + id;
        a.textContent = heading.textContent;
        a.addEventListener('click', (e) => {
          e.preventDefault();
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + id);
        });

        li.appendChild(a);
        fragment.appendChild(li);
      });

      this.tocList.appendChild(fragment);
    }

    setupScrollSpy() {
      if (this.headings.length === 0) return;

      const links = this.tocList.querySelectorAll('.mcp__toc-link');

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;

            links.forEach(link => {
              link.classList.toggle(
                'mcp__toc-link--active',
                link.getAttribute('href') === '#' + id
              );
            });
          }
        });
      }, {
        rootMargin: '-80px 0px -70% 0px',
        threshold: 0
      });

      this.headings.forEach(h => this.observer.observe(h.el));
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  if (!customElements.get('mc-policy-page')) {
    customElements.define('mc-policy-page', McPolicyPage);
  }

  } catch(e) { console.error(e); }
})();
})();
